import { z } from 'zod';
export const institutionConfigureSchema = z
    .object({
    key: z.string().uuid(),
    programmeId: z.string().uuid(),
    expectedVersion: z.number().int().positive(),
    goal: z.string().trim().min(1).max(1000),
    officialUrl: z.string().url().startsWith('https://').max(500),
    cohort: z.string().trim().min(1).max(100).nullable(),
    deadlineAt: z.string().datetime({ offset: true }).nullable(),
    timeZone: z
        .string()
        .min(1)
        .max(100)
        .refine((s) => {
        try {
            new Intl.DateTimeFormat('en', { timeZone: s });
            return true;
        }
        catch {
            return false;
        }
    }, 'Choose an IANA time zone.'),
    companyId: z.string().uuid().nullable(),
    leadAgent: z.string().uuid().nullable(),
    // A real existing task, not an arbitrary provider/source id or a new autonomous run.
    leadTaskId: z.string().uuid().nullable(),
})
    .strict()
    .refine((v) => Boolean(v.leadAgent) === Boolean(v.leadTaskId), {
    message: 'Choose both a department research agent and its existing assigned task, or neither.',
    path: ['leadTaskId'],
});
//# sourceMappingURL=institution-configuration.js.map